// Values reflect Wix dev center App Component IDs
export const PROFILE = 'profile';
export const ABOUT = 'about';
export const FOLLOWING_FOLLOWERS = 'following-followers'; // TODO: split into FOLLOWING and FOLLOWERS.
export const MEMBERS = 'members';
export const SIGN_UP = 'sign-up';
export const MODAL = 'modal';
export const PUBLIC_COMMUNITY_MODAL = 'public-community-modal';
export const BADGES = 'badges';
